// @ts-strict-ignore
import { Dictionary } from 'typescript-collections';
import { ArticleVO } from '@article/model/vo/article.vo';
import { ComplexProjectVO } from '@project/model/vo/project.vo';
import { Injectable } from '@angular/core';
import { LoadArticleProjectService } from '@project/service/load-article-project.service';
import { CompositeModelDataHolder } from '@3d-scene/model3d/cache/model-data';

@Injectable({ providedIn: 'root' })
export class CompositeArticleCacheManager {
  private static readonly KEY_DELIMITER: string = '_';
  private _compositeArticleProjectCache: Dictionary<string, ComplexProjectVO> = new Dictionary<string, ComplexProjectVO>();

  constructor(private loadArticleProjectService: LoadArticleProjectService) {}

  public async loadCompositeArticle(article: ArticleVO): Promise<CompositeModelDataHolder> {
    const complexProject: ComplexProjectVO = this.getProjectFromCache(article);
    if (complexProject) {
      return this.loadArticleProjectService.loadCompositeConfigurationModel(article, complexProject);
    } else {
      const compositeModelDataHolder = await this.loadArticleProjectService.loadCompositeArticleProject(article);
      this.storeProjectInCache(article, compositeModelDataHolder.complexProject);
      return compositeModelDataHolder;
    }
  }

  private getProjectFromCache(article: ArticleVO): ComplexProjectVO {
    let result: ComplexProjectVO = null;
    const key: string = this.getCacheKey(article);
    if (this._compositeArticleProjectCache.containsKey(key)) {
      result = this._compositeArticleProjectCache.getValue(key);
    }
    return result;
  }

  private storeProjectInCache(article: ArticleVO, complexProject: ComplexProjectVO): void {
    const key: string = this.getCacheKey(article);
    this._compositeArticleProjectCache.setValue(key, complexProject);
  }

  private getCacheKey(article: ArticleVO): string {
    return article.identity + CompositeArticleCacheManager.KEY_DELIMITER + article.version;
  }
}
